export default {
  "bonusRecord.title": "奖金记录",
  "bonusRecord.action.details": "详情",
  "bonusRecord.copy.success": "已复制到剪贴板",
  "bonusRecord.tooltip.copy.userNo": "复制用户编号: {text}",
  "bonusRecord.tooltip.showUserDetails": "显示用户详情",
  "bonusRecord.modal.title.details": "详情",
  "bonusRecord.modal.title.userDetails": "用户详情",
  "bonusRecord.column.no": "#序号",
  "bonusRecord.column.userNo": "用户编号",
  "bonusRecord.column.email": "邮箱",
  "bonusRecord.column.name": "姓名",
  "bonusRecord.column.firstName": "名",
  "bonusRecord.column.lastName": "姓",
  "bonusRecord.column.inviterUserno": "邀请人用户编号",
  "bonusRecord.column.inviterEmail": "邀请人邮箱",
  "bonusRecord.column.inviterName": "邀请人姓名",
  "bonusRecord.column.inviterFirstName": "推荐人名",
  "bonusRecord.column.inviterLastName": "推荐人姓",
  "bonusRecord.column.bonusCategory": "奖金类别",
  "bonusRecord.column.channel": "渠道",
  "bonusRecord.column.referral": "推荐",
  "bonusRecord.column.vipLevel": "VIP等级",
  "bonusRecord.column.lastLoginIp": "最后登录IP",
  "bonusRecord.column.bonusAmount": "奖金金额",
  "bonusRecord.column.todayReceiveNum": "今日领取次数",
  "bonusRecord.column.yesterdayReceiveNum": "昨日领取次数",
  "bonusRecord.column.totalReceiveNum": "总领取次数",
  "bonusRecord.column.lastReceiveTime": "最后领取时间",
  "bonusRecord.column.action": "操作",
  "bonusRecord.search.createTime": "创建时间",
  "bonusRecord.search.userNo": "用户编号",
  "bonusRecord.search.email": "邮箱",
  "bonusRecord.search.firstName": "名",
  "bonusRecord.search.lastName": "姓",
  "bonusRecord.search.inviterUserno": "邀请人用户编号",
  "bonusRecord.search.inviterEmail": "邀请人邮箱",
  "bonusRecord.search.inviterFirstName": "邀请人名",
  "bonusRecord.search.inviterLastName": "邀请人姓",
  "bonusRecord.search.vipLevel": "VIP等级",
  "bonusRecord.search.bonusCategory": "奖金类别",
};
